export const videoPreview = (
    inputUpload: HTMLInputElement,
    videoElement: HTMLVideoElement, 
    videoContainer: HTMLDivElement, 
    removeVideo: HTMLButtonElement, 
    uploadContainer?: HTMLDivElement) => {
        if (inputUpload) {
            inputUpload.addEventListener('change', (e) => {
                const target = e.target as HTMLInputElement
                if (target.files && target.files[0]) {
                    
                    // Show FileName
                    const videoName: HTMLParagraphElement | null = document.querySelector('.movie_fileName')
                    videoName && (videoName.innerText = target.files[0].name)
                    
                    // Show video preview
                    const readerVideo: FileReader = new FileReader()

                    readerVideo.onload = function(e) {
                        if (typeof e.target?.result === 'string') {
                            videoElement.src = e.target.result
                            videoElement.load()
                        }
                    }
                    
                    readerVideo.readAsDataURL(target.files[0])
                    videoContainer.style.display = 'block'
                    
                    uploadContainer && (uploadContainer.style.display = 'none')
                }
            })
        }

        removeVideo && removeVideo.addEventListener('click', () => {
            uploadContainer && (uploadContainer.style.display = 'block')
            videoContainer.style.display = 'none'
        })
}